module.exports={"(optional)":"(opcionális)","(required)":"(kötelező)"};